import type { TaskRouterOptions } from "./TaskRouterOptions";




export const getDefaultTaskRouterOptions = (): TaskRouterOptions => ({
    workerOptions: {
        setWorkerOfflineIfDisconnected: true
    }
});
